import React from 'react';
import { IMG } from '../data/constants';

const BG_COLORS = [
  'linear-gradient(160deg, #5b8ab8 0%, #1f4a75 100%)',
  'linear-gradient(160deg, #6e9cc4 0%, #284f7b 100%)',
  'linear-gradient(160deg, #4a7bab 0%, #17365a 100%)',
];

const WhyGMIS = ({ t, whyIdx, setWhyIdx }) => (
  /* full-width paper bg */
  <div className="w-full bg-paper">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-[120px] h-[640px] box-border flex flex-col justify-center gap-[44px]">

      <h2 className="m-0 font-heading font-medium text-[46px] leading-[1.1] text-navy tracking-[-0.015em] uppercase">
        {t.whyTitle}
      </h2>

      <div className="flex gap-4 h-[400px]">
        {t.why.map((w, i) => {
          const isActive = whyIdx === i;
          return (
            <button
              key={i}
              aria-expanded={isActive}
              onClick={() => setWhyIdx(i)}
              onMouseEnter={() => setWhyIdx(i)}
              className="group relative min-w-0 h-[400px] p-0 border-0 text-left overflow-hidden rounded-[8px] text-white cursor-pointer"
              style={{
                flex: isActive ? '2.4 1 0' : '1 1 0',
                background: BG_COLORS[i],
                transition: 'flex 0.35s ease',
              }}
            >
              {/* Image */}
              <img src={IMG.why[i]} alt="" className="absolute inset-0 w-full h-full object-cover block transition-transform duration-500 ease-out" />

              {/* Veil overlay */}
              <span
                className="absolute inset-0"
                style={{
                  background: isActive
                    ? 'linear-gradient(to top, rgba(14,36,62,0.94) 0%, rgba(14,36,62,0.4) 65%, rgba(14,36,62,0.12) 100%)'
                    : 'linear-gradient(to top, rgba(14,36,62,0.96) 0%, rgba(14,36,62,0.62) 100%)',
                }}
              />

              {/* Bottom text */}
              <span className="absolute left-0 right-0 bottom-0 box-border p-7 flex flex-col gap-3">
                <span className="block text-[13px] font-bold tracking-[0.16em] text-gold">
                  {'0' + (i + 1)}
                </span>
                <div
                  className="grid transition-all duration-500 ease-out"
                  style={{ gridTemplateRows: isActive ? '1fr' : '0fr', opacity: isActive ? 1 : 0 }}
                >
                  <div className="overflow-hidden flex flex-col gap-3">
                    <span className="block font-heading font-semibold text-[24px] leading-[1.25]">
                      {w.title.includes('. BSEISI:') ? (
                        <>
                          <span className="block text-[24px]">{w.title.split('. BSEISI:')[0]}</span>
                          <span className="block text-[13.5px] font-medium text-gold/95 mt-1 tracking-normal font-sans">
                            BSEISI: {w.title.split('. BSEISI:')[1]}
                          </span>
                        </>
                      ) : (
                        w.title
                      )}
                    </span>
                    <span className="block max-w-[420px] text-base leading-[1.6] text-white/90 pb-2">
                      {w.desc}
                    </span>
                  </div>
                </div>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  </div>
);

export default WhyGMIS;
